import React from 'react';
import { useTranslation } from 'react-i18next';

// The required-field marker. A word, not an asterisk: screen readers skip a bare
// "*".
const RequiredTag = () => {
  const { t } = useTranslation();

  return (
    // The leading space separates it in the label's accessible name, which is
    // the text run together ("Email Required", not "EmailRequired").
    <>
      {' '}
      <span className="ml-2 rounded bg-greyscale-10 px-1.5 py-0.5 align-middle text-[11px] font-medium uppercase tracking-wide text-greyscale-5 transition-colors duration-300">
        {t('Required')}
      </span>
    </>
  );
};

export default RequiredTag;
